import { DocumentsList } from './external-documents-form.type'

export const documentsList: DocumentsList = [{
  // COA - Certificado de calidad
  fileTranslationId: 'tabDocumentsExternalFormShipmentCustomCertificate',
  file: 'shipmentCustomCertificateFile',
  configRequest: {
    fileField: 'shipment_custom_certificate_file',
    method: 'PATCH',
  },
}]


export default documentsList
